export default "__VITE_ASSET__BNdP9CrY__"